import React, { useEffect, useState } from "react";
import WifiOffIcon from "@mui/icons-material/WifiOff";

export default function NetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (isOnline) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        width: "100%",
        backgroundColor: "#d32f2f",
        color: "white",
        textAlign: "center",
        padding: "8px 0",
        zIndex: 2000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        fontWeight: 500,
      }}
    >
      <WifiOffIcon style={{ fontSize: 20 }} />
      <span>No Internet Connection</span>
    </div>
  );
}
